import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import PartnerService from "../../services/partners.service";
import SectionTitle from "../../components/SectionTitle";

const media = [
  {"logoUrl":"/img/Media/1.JPG"},
  {"logoUrl":"/img/Media/2.jpg"},
  {"logoUrl":"/img/Media/3.png"},
  {"logoUrl":"/img/Media/4.png"},
  {"logoUrl":"/img/Media/5.jpg"},
  {"logoUrl":"/img/Media/6.jpg"},
  {"logoUrl":"/img/Media/7.png"},
  {"logoUrl":"/img/Media/8.jpg"},
  {"logoUrl":"/img/Media/9.jpg"},
  {"logoUrl":"/img/Media/10.png"},
  {"logoUrl":"/img/Media/11.png"},
  {"logoUrl":"/img/Media/12.png"},
  {"logoUrl":"/img/Media/13.png"},
  {"logoUrl":"/img/Media/14.png"},
];

const AwardsAndRecogination = ({ type = "" }) => {
  const [awards, setAwards] = useState([]);

  const awardsSetting = {
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    PartnerService.awardList()
      .then((res) => setAwards(res.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="react-clients react-clientso home-testimonial py-5 ">
      <div className="container">{
        type==="media" ? 
        <SectionTitle Title="Media & " subtitle="Coverage" />
        :
        <SectionTitle Title="Awards & " subtitle="Recognitions" />
        }
        <div
          className="client-slider m-0 col-12 wow animate_fadeInUp mb-md-5"
          data-wow-duration="0.3s"
        >
          <Slider {...awardsSetting}>
            {(type==="media" ? media :awards)?.map((item, idx) => (
              <div key={idx} className="m-2 ">
                <div className="awards_card bg-white mx-2 shadow">
                  <img
                    src={item.logoUrl}
                    width={320}
                    height={320}
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                    className=" h-full w-full rounded"
                    alt=""
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default AwardsAndRecogination;
